const DISMISSED_ORDER_SESSION_STORAGE_KEY = 'dismissedAmendTooltipOrderId';

export const isAmendOrderAlertTooltipOpen = (
  dismissedAmendTooltipOrderId: string | undefined,
  currentOrderId: string,
) => dismissedAmendTooltipOrderId !== currentOrderId;

export const setDismissedAmendTooltipOrderId = (dismissedAmendTooltipOrderId: string) => {
  window.sessionStorage.setItem(DISMISSED_ORDER_SESSION_STORAGE_KEY, dismissedAmendTooltipOrderId);
};

export const getDismissedAmendTooltipOrderId = () =>
  window.sessionStorage.getItem(DISMISSED_ORDER_SESSION_STORAGE_KEY) || undefined;
